// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"05d74115","546":"343183b8","757":"8d133c6b"}[chunkId] + ".css";
};